export default __webpack_public_path__ + "static/media/480_dummy2016-kosmetik01-de.ae3069cb.png";